import styled from 'styled-components';
import colors from '../../config/colors';

const CookiesContent = styled.div`
  flex: 1;
  padding: 0 15px;
  padding-right: 34px;

  &.showDetails {
    flex: 0 0 50%;
  }

  @media (max-width: 991px) {
    padding-right: 15px;
  }
`;

const ButtonsInline = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;

  button {
    margin-right: 30px;
  }

  span {
    font-size: 12px;
    color: ${colors.TEXT_BLACK};
    cursor: pointer;
    transition: color 100ms ease-in-out;
    margin-left: auto;

    i {
      font-style: normal;
      margin-left: 4px;
    }

    &:hover {
      color: ${colors.TEXT_GRAY};
    }
  }
`;

const CookiesDetails = styled.div`
  flex: 1;
  padding: 0 15px;
  padding-left: 34px;
  display: none;
  border-left: 1px solid rgb(128, 128, 128);

  @media (max-width: 991px) {
    padding-left: 15px;
  }

  @media (max-width: 767px) {
    margin-top: 20px;
    border-left: none;
  }

  &.showDetails {
    display: block;
  }

  h4 {
    font-size: 14px;
    color: ${colors.TEXT_BLACK};
    margin: 8px 0;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 16px;
  }

  li {
    color: ${colors.TEXT_BLACK};
    margin-bottom: 3px;
  }

  label {
    color: ${colors.TEXT_BLACK};
    transition: color 100ms ease-in-out;

    &:hover {
      color: ${colors.TEXT_GRAY};
    }

    input {

      &:checked ~ span {
        background-color: ${colors.TEXT_GRAY};
        border-color: ${colors.TEXT_GRAY};
      }
    }
  }
`;

const CookiesDetailsRow = styled.div`
  display: flex;
  margin: 0 -30px;

  @media (max-width: 767px) {
    margin: 0 -10px;
  }
`;

const CookiesDetailsCol = styled.div`
  padding: 0 30px;

  @media (max-width: 767px) {
    padding: 0 10px;
  }
`;

export {
  CookiesContent,
  ButtonsInline,
  CookiesDetails,
  CookiesDetailsRow,
  CookiesDetailsCol
};
